var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4140625,12l5.6225586-5.6225586c0.390625-0.390625,0.390625-1.0234375,0-1.4140625 s-1.0234375-0.390625-1.4140625,0L12,10.5859375L6.3774414,4.9633789c-0.390625-0.390625-1.0234375-0.390625-1.4140625,0 s-0.390625,1.0234375,0,1.4140625L10.5859375,12l-5.6225586,5.6225586c-0.390625,0.390625-0.390625,1.0234375,0,1.4140625 c0.1953125,0.1953125,0.4511719,0.2929688,0.7070312,0.2929688s0.5117188-0.0976562,0.7070312-0.2929688L12,13.4140625 l5.6225586,5.6225586c0.1953125,0.1953125,0.4511719,0.2929688,0.7070312,0.2929688s0.5117188-0.0976562,0.7070312-0.2929688 c0.390625-0.390625,0.390625-1.0234375,0-1.4140625L13.4140625,12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.136b62390bcc40e025bdc12b4fef4692.svg";
export { ForwardRef as ReactComponent };